<template>
  <div class="field">
    <label>{{ label }}</label>
    <div class="autocomplete">
      <input
          v-model="search"
          type="text"
          :placeholder="placeholder"
          @input="onChange"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
          class="autocomplete_input"
      />
      <ul v-show="isOpen" class="autocomplete-results">
        <li v-if="isLoading" class="loading">Загрузка данных...</li>
        <li
            v-else
            v-for="(result, i) in results"
            @click="setResult(result)"
            :key="i"
            class="autocomplete-result"
            :class="{ 'is-active': i === arrowCounter }"
        >
          <template v-if="searchKey.length > 0">
            {{ result[searchKey] }}
          </template>
          <template v-else>
            {{ result }}
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
module.exports = {
  name: "search-autocomplete",
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: ""
    },
    //Исходные данные по которым будет выполняться поиск
    //Если передаем массив объектов, нужно также передать searchKey.
    //Можно также просто передать массив значений, тогда searchKey не обязательный
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    //Ключ, куда подставлять значение для родительского объекта
    parentResultKey: {
      type: String,
      required: true,
      default: "",
    },
    //Подстановка уже выбранного значения в search
    defaultvalue: {
      type: String,
      required: true,
      default: "",
    },
    //Ключ, если передается массив объектов во входные данные
    searchKey: {
      type: String,
      required: false,
      default: "",
    },
    //Искать по API запросу передавая в него введенную строку
    searchApi: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      search: "",
      results: [],
      isOpen: false,
      isFormSubmittedVal: this.isFormSubmitted,
      arrowCounter: -1,
      isLoading: false,
    };
  },
  inject: ["$validator"],
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.search = this.defaultvalue;
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    filterResults() {
      let items = this.items;
      if (this.searchKey.length > 0) {
        this.results = items.filter(item => item[this.searchKey]?.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
      } else {
        this.results = items.filter(
            (item) => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      }
    },
    setResult(result) {
      if (this.searchKey.length > 0) {
        this.search = result[this.searchKey];
      } else {
        this.search = result;
      }
      this.setParentResult(result);
      this.isOpen = false;
    },
    onChange() {
      if (this.searchApi) {
        const self = this;
        if (this.search.length > 1) {

          //На будущее. Эту логику нужно вынести вне компонента
          window.$.ajax({
            dataType: "json",
            type : 'post',
            data: { query: this.search },
            url: '/user/getExperts',
            success: function() {
              self.filterResults();
              self.isOpen = true;
            },
            error: function() {
              alert('Ошибка получения данных');
            }
          });
        }
      }
      else {
        this.filterResults();
        this.isOpen = true;
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.arrowCounter = -1;
        this.isOpen = false;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      if (this.searchKey.length > 0) {
        this.search = this.results[this.arrowCounter][this.searchKey];
      } else {
        this.search = this.results[this.arrowCounter];
      }
      this.setParentResult(this.results[this.arrowCounter]);
      this.arrowCounter = -1;
      this.isOpen = false;
    },
    setParentResult(result) {
      this.$parent[this.parentResultKey] = result;
    },
  },
};
</script>
<style>
.autocomplete {
  position: relative;
}
.autocomplete_input {
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: 16px 18px;
  background-position: 98% 50%;
  cursor: auto;
}
.autocomplete .autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 150px;
  min-height: 1em;
  overflow: auto;
}
.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}
.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>